module.exports = __webpack_public_path__ + "img/poker-h09.34015cbb.svg";